/** Canonical conversions. Drawing coordinates and catalogue dimensions remain feet. */
export const SQ_METRES_PER_ACRE = 4046.8564224;
export const SQ_FEET_PER_ACRE = 43560;
export const FEET_PER_METRE = 1 / 0.3048;
